export function cartesianProduct<T>(arrays: T[][]): T[][] {
  if (!arrays.length) return [];
  return arrays.reduce<T[][]>(
    (acc, current) => acc.flatMap((combo) => current.map((item) => [...combo, item])),
    [[]],
  );
}

export function buildVariantKey(attributeValueIds: string[]): string {
  return [...attributeValueIds].sort().join(':');
}

export function mergeVariants<T extends { attributeValueIds: string[] }>(
  generated: T[],
  existing: T[],
): T[] {
  const existingMap = new Map(
    existing.map((variant) => [buildVariantKey(variant.attributeValueIds), variant]),
  );

  return generated.map((variant) => {
    const key = buildVariantKey(variant.attributeValueIds);
    return existingMap.get(key) ?? variant;
  });
}
